export const KEYBOARD_KEY_HINTS = {
  Discard: 'Press Esc to discard',
  Save: 'Press Enter to save',
} as const;
